<template>
  <div>
    <Page title="メールテンプレート管理">
      <template v-slot:content>
        <div class="table-action">
          <div>
            <div class="search-field">
              <SearchField
                @search="onSearch"
                :count="mailTemplates && mailTemplates.length"
                :tableData="mailTemplates"
                :filterColumns="filterColumns"
                :key="renewKey"
              />
            </div>
            <ActionButton title="テンプレート作成" color="default" icon="plus" @click="onAddMailTemplateButtonClick" />
          </div>
        </div>
        <div class="uk-card uk-card-default uk-card-body">
          <Table :header="header" :tableData="mailTemplates" @column-click="onColumnClick" />
        </div>
      </template>
    </Page>
    <div class="uk-flex-top email-template-form" uk-modal ref="email-template" :bg-close="false">
      <EmailTemplateForm :key="emailTemplateFormKey" :mailTemplate="mailTemplate" @submitted="onEmailTemplateSubmitted" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
@include modal-form;
.search-field {
  margin-right: $spacing-medium;
}
div:deep(table) {
  td.col:nth-child(2) > div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5em;
    max-height: 4.5em;
    max-width: 500px;
    overflow-wrap: break-word;
  }
  td.col:nth-child(1) > div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5em;
    max-height: 4.5em;
    max-width: 200px;
    overflow-wrap: break-word;
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { SystemApi, GetEmailTemplate } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import EmailTemplateForm from "../organisms/EmailTemplateForm.vue";
import SearchField from "../atoms/SearchField.vue";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    SearchField,
    EmailTemplateForm
  }
})
export default class MailTemplates extends Vue {
  mailTemplates: GetEmailTemplate[] = [];
  mailTemplate: GetEmailTemplate | null = null;
  @Ref("email-template") templateFormModal!: HTMLElement;
  emailTemplateFormKey = 0;
  header = [
    { title: "テンプレート名", sortable: true, key: "name", width: "expand" },
    {
      title: "テンプレート本文(一部抜粋)",
      sortable: true,
      key: "mesagePart",
      width: "expand"
    },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name", "mesage"];
  query = "";
  renewKey = 0;

  private async loadData() {
    const templatesResponse = await new SystemApi().getEmailTemplates({
      q: this.query
    });
    this.mailTemplates = templatesResponse.data.map(r =>
      Object.assign(r, {
        mesagePart: r.message.slice(0, 100).replace(/\r?\n/g, " ")
      })
    );
    this.renewKey = Date.now();
  }
  async beforeMount() {
    this.loadData();
  }
  onAddMailTemplateButtonClick() {
    this.emailTemplateFormKey = Date.now();
    this.mailTemplate = null;
    UIkit.modal(this.templateFormModal).show();
  }
  onEmailTemplateSubmitted() {
    this.loadData();
    UIkit.modal(this.templateFormModal).hide();
  }
  async onSubmitted() {
    UIkit.modal(this.templateFormModal).hide();
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.mailTemplates = searchResult;
    } else {
      await this.loadData();
    }
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.mailTemplate = this.mailTemplates[location.row];
      this.emailTemplateFormKey = Date.now();
      UIkit.modal(this.templateFormModal).show();
    }
  }
}
</script>
